import { render, staticRenderFns } from "./PlanDeposits.vue?vue&type=template&id=265b0ca2&scoped=true"
import script from "./PlanDeposits.vue?vue&type=script&lang=js"
export * from "./PlanDeposits.vue?vue&type=script&lang=js"
import style0 from "./PlanDeposits.vue?vue&type=style&index=0&id=265b0ca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265b0ca2",
  null
  
)

export default component.exports